import { render, staticRenderFns } from "./ShiftsStatsDialog.vue?vue&type=template&id=74f07250&scoped=true"
import script from "./ShiftsStatsDialog.vue?vue&type=script&lang=js"
export * from "./ShiftsStatsDialog.vue?vue&type=script&lang=js"
import style0 from "./ShiftsStatsDialog.vue?vue&type=style&index=0&id=74f07250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f07250",
  null
  
)

export default component.exports